import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
// Components
import { List, Avatar, Tag, Space, Flex, message } from 'antd';
import StepsHeading from './StepsHeading';
import { CheckOutlined, ClockCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { CustomButton, CustomModalWithoutButton, CustomParagraph, ManufacturerSearch } from '../../../components';
import ConnectFormModal from '../../Modals/ConnectFormModal';
import LinkIcon from "../../../assets/images/link-icon.svg";
import { useSpin } from '../../../components/SpinContext';
import { useToken } from '../../../common/helper';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllCouriers, selectCouriersState } from '../../../reudx-toolkit/slice/onboardingSlice';
import chevronRight from "../../../assets/images/chevron-right.svg";
import { DeleteCourierAccount } from '../../../api\'s/onboarding';
import { getProviderImagePath } from '../../../common/utils/imageUtils';
import ZLShield from '../../../assets/images/ZLshield.png';
import Arrows from '../../../assets/images/arrows.png';



const Couriers = ({ onNext }) => {
  const [list, setList] = useState([]);
  const [filteredData, setFilteredData] = useState(list);
  const [searchText, setSearchText] = useState("")
  const { showSpin, hideSpin } = useSpin();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalName, setModalName] = useState("");
  const { token, removeToken } = useToken();
  const navigate = useNavigate();
  const [courier, setCourier] = useState(null);
  const dispatch = useDispatch();
  const state = useSelector(selectCouriersState);
  const [requestStatus, setRequestStatus] = useState(null);
  const [showIntegrationMessageIndex, SetShowIntegrationMessageIndex] = useState(-1);



  useEffect(() => {
    if (dispatch) {
      dispatch(fetchAllCouriers(token))
    }
  }, [dispatch]);

  useEffect(() => {
    if (state) {
      setRequestStatus(state?.status ? state.status : null)
      if (state?.courierList.length > 0) {
        setList(state?.courierList);
        setFilteredData(state?.courierList);
      }
    }
  }, [state]);





  useEffect(() => {
    if (requestStatus) {
      unauthorize(requestStatus);
    }
  }, [requestStatus])

  const unauthorize = (status) => {
    if (status === 401) {
      removeToken();
      navigate("/login");
    }
  }


  const handleListMessage = (item) => {

    setFilteredData((prevList) =>
      prevList.map((ele) =>
        ele.id === item.id ? { ...ele, isIntegratedMessage: true } : ele
      )
    );
  };

  const handleBasicTracking = (item) => {
    setFilteredData((prevList) =>
      prevList.map((ele) =>
        ele.id === item.id ? { ...ele, showBasicTracking: (item?.is_public || item?.is_zoom_logi_provider) ? true : false } : ele
      )
    );
  };





  const fetchData = async () => {
  };

  const handleDelete = (item) => {
    if (item && item?.company_courier) {
      showSpin();
      DeleteCourierAccount(item?.company_courier, token)
        .then((res) => {
          const data = res?.data || null;
          if (data) {
            if (data.data?.is_success) {
              message.success(data?.data?.message)
              dispatch(fetchAllCouriers(token))
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        }).finally(() => {
          hideSpin();
        });
    }
  }


  const handleButtonClick = (item) => {
    if (item) {
      setCourier(item);
      setModalName(item?.title ? item.title : "");
    }
    setModalOpen(true);
  };

  const onModalConfirm = () => {
    setModalOpen(false);
    dispatch(fetchAllCouriers(token));
    setCourier(null);
    setModalName("")
  }

  const handleSearch = (event) => {
    const searchValue = event.target.value.toLowerCase();
    setSearchText(searchValue);

    if (searchValue.trim() === "") {
      setFilteredData(list);
    } else {
      const filteredItems = list.filter((item) =>
        item.title.toLowerCase().includes(searchValue)
      );
      setFilteredData(filteredItems);
    }
  };

  return (
    <>
      <div className="default-steps-content">
        <StepsHeading
          heading="Connect your transport providers"
          text="Connect your transport providers to track shipments in real time, all in one place. Choose Basic Tracking for broad updates or Advanced Tracking for richer status updates and more accurate ETAs" />

        <ManufacturerSearch
          placeholder="Search for a transport provider..."
          width="420px"
          borderRadius="50px"
          height="36px"
          bgColor="#E6E6E6"
          value={searchText}
          search={handleSearch}
        />

        <List
          className="custom-list-container"
          itemLayout="horizontal"
          dataSource={filteredData}
          renderItem={(item, index) => {
            const imagePath = getProviderImagePath(item.title, 'transportProvider');

            return (
              <List.Item>
                <List.Item.Meta
                  avatar={<Avatar src={<img src={imagePath} alt="avatar" style={{ width: "100%", height: "100%", objectFit: "contain" }} />} />}
                  title={
                    <>
                      <Space style={{ display: "flex" }}>
                        <CustomParagraph fontSize={14} fontWeight={500} color="#000" text={item.title} marginBottom={0} />
                        {item?.is_enabled ? (
                          item?.status === null ? (
                            (item?.is_zoom_logi_provider || item?.is_public) && (
                              <Tag color="success" icon={<CheckOutlined style={{ color: "#0E8345" }} />}>
                                Basic Tracking
                              </Tag>
                            )
                          ) : item?.status !== null ? (
                            !item?.is_zoom_logi_provider && !item?.is_public && (
                              item?.status === "pending" ? (
                                <Tag color="default" icon={<ClockCircleOutlined style={{ color: "#5E5E5E" }} />}>
                                  Checking Credentials
                                </Tag>
                              ) : item?.status === "linked" ? (
                                <Tag color="success" icon={<CheckOutlined style={{ color: "#0E8345" }} />}>
                                  Synced
                                </Tag>
                              ) : item?.status === "basic" ? (
                                <Tag color="success" icon={<CheckOutlined style={{ color: "#0E8345" }} />}>
                                  Basic Tracking
                                </Tag>
                              ) : item?.status === "error" ? (
                                <Tag color="error" icon={<CloseOutlined style={{ color: "#DE1135" }} />}>
                                  Incorrect Access Credentials
                                </Tag>
                              ) : null
                            )
                          ) : null
                        ) : null}
                      </Space>
                    </>
                  }
                />

                {item.is_enabled ? (
                  item?.status === null ? (
                    !item?.is_zoom_logi_provider && !item.is_public ? (
                      <CustomButton
                        onClick={() => handleButtonClick(item)}
                        height="36px"
                        fontSize="14px"
                        text="Link account"
                        bgColor="#E6E6E6"
                        borderRadius="8px"
                        color="#000"
                        boxShadow="none"
                        iconPosition="left"
                        image={LinkIcon}
                        gap="10px"
                        fontWeight={500}
                      />
                    ) : (item?.is_zoom_logi_provider || item.is_public ? (
                      ""
                    ) : null)
                  ) : item.status !== null ? (
                    item.status === "pending" ? (
                      <div style={{ width: "26px",textAlign:"center" }}>
                      <CloseOutlined style={{ color: "#5E5E5E" }} onClick={() => handleDelete(item)} />
                      </div>
                    ) : item.status === "basic" ? (
                       <div style={{ width: "26px",textAlign:"center" }}>
                        <CloseOutlined style={{ color: "#5E5E5E" }} onClick={() => handleDelete(item)} />
                      </div>
                    ) : (item.status === "linked" || item.status === "error") ? (
                      <img
                        style={{ color: "#5E5E5E", cursor: "pointer" }}
                        src={chevronRight}
                        alt=""
                        onClick={() => handleButtonClick(item)}
                      />
                    ) : null
                  ) : null
                ) : (
                  <Flex align="center" justify="center">
                    {item.isIntegratedMessage ? (
                      <p
                        style={{
                          color: "#5E5E5E",
                          fontSize: 12,
                          whiteSpace: "nowrap",
                          marginBottom: 0,
                          marginRight: "10px",
                        }}
                      >
                        A ZoomLogi representative will reach out to you to complete integration
                      </p>
                    ) : (
                      <CustomButton
                        onClick={() => handleListMessage(item)}
                        height="36px"
                        fontSize="14px"
                        text="Link account"
                        bgColor="#E6E6E6"
                        borderRadius="8px"
                        color="#000"
                        boxShadow="none"
                        iconPosition="left"
                        image={LinkIcon}
                        gap="10px"
                        fontWeight={500}
                      />
                    )}
                  </Flex>
                )}
              </List.Item>
            );
          }}
        />

        {modalOpen && courier && (
          <CustomModalWithoutButton
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            modalTitle={`Connect to ${modalName} for advanced tracking`}
            modalText={`By providing API access to ZoomLogi, you're enabling ZoomLogi to retrieve your shipment information.`}
            modalSize={795}
            modalBorderRadius={"16px"}
            headerIcon={
              <Flex align="center" justify="center" gap={12}>
                <Avatar
                  src={<img src={getProviderImagePath(courier.title, 'transportProvider')} alt={courier.title} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />}
                  size={52}
                  style={{
                    backgroundColor: 'transparent',
                    boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.15)',
                    borderRadius: '50%'
                  }}
                />
                <img src={Arrows} alt="connects to" style={{ height: '40px' }} />
                <Avatar
                  size={52}
                  style={{
                    backgroundColor: 'transparent',
                    boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.15)',
                    borderRadius: '50%',
                  }}
                >
                  <div style={{ padding: '6px', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <img src={ZLShield} alt="ZoomLogi" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                  </div>
                </Avatar>
              </Flex>
            }
          >
            <ConnectFormModal data={courier} closeModal={() => setModalOpen(false)} onSuccess={onModalConfirm} reset={modalOpen}
            />
          </CustomModalWithoutButton>
        )}
      </div>
    </>
  );
};

export default Couriers;
